import EventEmitter from "events";
import { useEffect } from "react";
import { playing, speed } from "src/contexts/initData";

interface SharedState {
  startTime: number;
  idx: number;
  window: [string, string] | [];
  cmap: string;
  selectedVar: string;
  data: any[];
  playback: {
    playing: boolean,
    speed: number
  }
}

declare global {
  interface Window {
    sharedState: Partial<SharedState>;
  }
}

// Instead idx updating the global state every second, both systems 
// can use window.sharedState.startTime - Date.now() to see how far 
// into the timeseries to display

/** 
 * A time in milliseconds accessible from both systems to reference 
 * for counting time. Initializes to the current time when the page 
 * is loaded
 */
const startTime = Date.now();
window.sharedState = {
  startTime,
  idx: 0,
  playback: {
    playing,
    speed
  }
}

export enum SharedStateEvent {
  IDX_UPDATE = "idx_update",
  PLAYBACK_UPDATE = "playback_update",
  WINDOW_UPDATE = "window_update",
  CMAP_UPDATE = "cmap_update",
}

// export const EVENT_NAME = 'update';
export const StateUpdateEmitter = new EventEmitter();

/**
 * Update the shared state and emit event for listeners 
 */
export const updateSharedState = (EVENT_NAME: SharedStateEvent, newState: Partial<SharedState>) => {
  window.sharedState = {
    ...window.sharedState,
    ...newState,
  }
  StateUpdateEmitter.emit(EVENT_NAME, window.sharedState)
}

type SharedStateListener = (state: SharedState) => void
/**
 * Set a listener for shared state updates
 */
export const setSharedStateListener = (EVENT_NAME: SharedStateEvent, callback: SharedStateListener) => {
  StateUpdateEmitter.on(EVENT_NAME, callback)
  return () => {
    StateUpdateEmitter.off(EVENT_NAME, callback)
  }
}

export const useSharedStateListener = (EVENT_NAME: SharedStateEvent, callback: SharedStateListener) => {
  useEffect(() => {
    StateUpdateEmitter.on(EVENT_NAME, callback)
    return () => {
      StateUpdateEmitter.off(EVENT_NAME, callback)
    }
  }, [EVENT_NAME, callback])
}

